import { render, staticRenderFns } from "./ListDelivery.vue?vue&type=template&id=015b44fd&"
import script from "./ListDelivery.vue?vue&type=script&lang=js&"
export * from "./ListDelivery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports